@if (!recoveryComplete()) {
  <app-window class="reset-password">
    <span title>{{ 'features.resetPassword.title' | translate }}</span>
    <div body>
      <form class="reset-password-form" [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="reset-password-form__title">
          <h2>{{ 'features.resetPassword.title' | translate }}</h2>
        </div>

        <div class="reset-password-form__input">
          <label for="password">{{ 'features.resetPassword.form.password' | translate }}</label>
          <input name="password" type="password" id="password" formControlName="password" [class.error]="hasError('password')" />
        </div>
        <ng-container *ngTemplateOutlet="errorTemplate; context: { field: 'password' }" />
        <div class="reset-password-form__input">
          <label for="repeat-password">{{ 'features.resetPassword.form.repeatPassword' | translate }}</label>
          <input
            name="repeat-password"
            type="password"
            id="repeat-password"
            formControlName="repeatPassword"
            [class.error]="hasError('repeatPassword') || passwordMismatch" />
        </div>
        <ng-container *ngTemplateOutlet="errorTemplate; context: { field: 'repeatPassword' }" />
        @if (passwordMismatch) {
          <div class="reset-password__error-message">{{ 'features.register.errors.passwordsDontMatch' | translate }}</div>
        }
        <div class="reset-password-form__buttons">
          <button class="main-button" [disabled]="form.invalid || isSubmitting()">
            {{ 'features.resetPassword.form.submit' | translate }}
          </button>
        </div>
      </form>
    </div>
  </app-window>
} @else {
  <app-window class="reset-password">
    <span title>{{ 'features.resetPassword.title' | translate }}</span>
    <div body>
      <div class="reset-password-form">{{ 'features.resetPassword.success' | translate }}</div>
    </div>
  </app-window>
}

<ng-template #errorTemplate let-field="field">
  @if (hasError(field)) {
    <div class="reset-password__error-message">
      {{ getErrorMessage(field) | translate }}
    </div>
  }
</ng-template>
